import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/src/app/landing-page/components/LandingPageInteractive.tsx");
